<!-- campaign form with flights to fill all data  of a campaign and return it to the campaign edit component to submit
 this form includes 3 components
1. the general form -> where we have the general data of the campaign
2. flights (sub campaigns the also include general forms ) -> where we can edit and add flights 
3. target Data form where we add the target data if applicable
-->
<script lang="ts">
  import Validators from "../../utils/validators";
  import Form from "../form/Form.svelte";
  import FormButtons from "../form/FormButtons.svelte";
  import CollapseBox from "../form/CollapseBox.svelte";

  import InputWrapper from "../form/InputWrapper.svelte";
  import PlainInput from "../form/PlainInput.svelte";
  import DatePicker from "../form/DatePicker.svelte";

  import SingleCheckbox from "../form/SingleCheckbox.svelte";
  import InventoryForm from "./InventoryForm.svelte";
  import TrackingForm from "./TrackingForm.svelte";
  import AssetsForm from "./AssetsForm.svelte";
  import TraffickingForm from "./TraffickingForm.svelte";
  import TargetForm from "./TargetForm.svelte";
  import AudienceForm from "./AudienceForm.svelte";

  // state variables
  let impressions = 0;
  let showTargeting = false;
  let showAudience = false;
  let showInventory = false;
  let showTracking = false;
  let showAssets = false;
  let showExecution = false;

  export let flight = null;
  export let targeting = null;
  export let onClose: () => void;
  export let onSubmit: (e: any) => void;

  let placement_id = flight ? flight.name : "";
  let start_at = flight ? flight.start_at : "";
  let end_at = flight ? flight.end_at : "";
  let budget = flight ? flight.budget : "";

  const isUpdate = !!flight;

  let form: any;

  const rules: any = {
    name: {
      validators: [
        Validators.required("Placement ID is required"),
        Validators.minLength(4),
      ],
    },
    budget: {
      validators: [Validators.required("Budget is required")],
    },
    start_at: {
      validators: [Validators.required("Start Date is required")],
    },
    end_at: {
      validators: [Validators.required("End Date is required")],
    },
  };
</script>

<Form {rules} on:submit={onSubmit} bind:this={form}>
  <div class="w-full flex flex-row gap-2">
    <InputWrapper label="Placement ID">
      <PlainInput name="name" bind:value={placement_id} />
    </InputWrapper>
  </div>

  <!-- date times -->
  <div class="flex flex-row w-full gap-2">
    <div class="w-full">
      <DatePicker
        label="Start Date"
        name="start_at"
        initialValue={start_at}
        reset={true}
      />
    </div>

    <div class="w-full">
      <DatePicker
        label="End Date"
        name="end_at"
        initialValue={end_at}
        reset={true}
      />
    </div>
  </div>
  <!-- Budget & impressions -->
  <div class="flex flex-row w-full gap-2">
    <!-- <InputWrapper label="Budget Allocation"> -->
    <!--   <PlainInput name="budget" bind:value={budget} prefix="%" /> -->
    <!-- </InputWrapper> -->
    <InputWrapper label="Budget">
      <PlainInput name="budget" bind:value={budget} prefix="$" />
    </InputWrapper>
    <InputWrapper label="Impressions">
      <PlainInput disabled name="impressions" value={impressions} prefix="$" />
    </InputWrapper>
  </div>

  <CollapseBox title="Targeting" show={showTargeting}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showTargeting}
        />
      </div>
    </div>
    <TargetForm data={targeting} />
  </CollapseBox>
  <CollapseBox title="Audience" show={showAudience}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showAudience}
        />
      </div>
    </div>
    <AudienceForm />
  </CollapseBox>
  <CollapseBox title="Inventory" show={showInventory}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showInventory}
        />
      </div>
    </div>
    <InventoryForm />
  </CollapseBox>
  <CollapseBox title="Tracking" show={showTracking}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showTracking}
        />
      </div>
    </div>
    <TrackingForm />
  </CollapseBox>
  <CollapseBox title="Assets" show={showAssets}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showAssets}
        />
      </div>
    </div>
    <AssetsForm />
  </CollapseBox>
  <CollapseBox title="Execution" show={showExecution}>
    <div slot="expand-button">
      <div
        class="align-middle bg-white flex border-custom-orange h-[100%] justify-center easy mr-8`"
      >
        <SingleCheckbox
          styledCheckbox
          name=""
          label=""
          bind:value={showExecution}
        />
      </div>
    </div>
    <TraffickingForm />
  </CollapseBox>
  <FormButtons {isUpdate} on:cancel={onClose} />
</Form>
